import React, { useEffect, useRef } from 'react';
import CartResume from '../components/CartResume';
import { Card, Col, Container, Row } from 'react-bootstrap';
import styles from './Payment.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../components/Loader';
import PaymentBrick from '../components/PaymentBrick';
import StatusBrick from '../components/StatusBrick';
import { alertModal } from '../utils/modalController';

const apiUrl = process.env.REACT_APP_API_URL || '';

const Payment: React.FC = () => {
    const { paymentId } = useParams<{ paymentId: string }>();
    const [itensPagamento, setItensPagamento] = React.useState<{ title: string; valor: number }[]>([]);
    const [preferenceId, setPreferenceId] = React.useState<string | undefined>(undefined);
    const [paymentMethods, setPaymentMethods] = React.useState<{
        ticket: "all" | string[],
        bankTransfer: "all" | string[],
        creditCard: "all" | string[],
        prepaidCard: "all" | string[],
        debitCard: "all" | string[],
        mercadoPago: "all" | string[],
    }>({
        ticket: [],
        bankTransfer: [],
        creditCard: [],
        prepaidCard: [],
        debitCard: [],
        mercadoPago: [],
    });
    const [payed, setPayed] = React.useState<boolean>(false);
    const [paymentApproved, setPaymentApproved] = React.useState<boolean>(false);
    const [mounted, setMounted] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [paymentMpId, setPaymentMpId] = React.useState<string | undefined>(undefined);
    const desconto = useRef<number>(0);

    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const fetchPaymentItems = () => {
            fetch(`${apiUrl}/payments/create-preference/${paymentId}`)
                .then(async (response) => {
                    const responseJson = await response.json();
                    if (!response.ok) {
                        console.error('Erro na resposta da API: ', responseJson);
                        return Promise.reject(responseJson.message || 'Ocorreu um erro desconhecido.');
                    }
                    return responseJson;
                })
                .then((data) => {
                    setItensPagamento(data.items || []);
                    setPaymentMethods(data.paymentMethods || {
                        ticket: [],
                        bankTransfer: [],
                        creditCard: [],
                        prepaidCard: [],
                        debitCard: [],
                        mercadoPago: [],
                    });
                    setPreferenceId(data.preferenceId || undefined);
                    desconto.current = 0;
                })
                .catch(async (error) => {
                    console.error('Erro ao buscar itens de pagamento:', error);
                    await alertModal(error || 'Erro ao buscar itens de pagamento');
                    setItensPagamento([]);
                    setPaymentMethods({
                        ticket: [],
                        bankTransfer: [],
                        creditCard: [],
                        prepaidCard: [],
                        debitCard: [],
                        mercadoPago: [],
                    });
                    setPreferenceId(undefined);
                    desconto.current = 0;
                    navigate('/');
                })
                .finally(() => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 1000); // Simula um delay de 1 segundo para o loading
                });
        };

        fetchPaymentItems();
    }, [paymentId]);

    useEffect(() => {
        if (loading) setMounted(false);
        else setMounted(itensPagamento.length > 0);
    }, [loading, paymentId, payed, paymentApproved, itensPagamento]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                setMounted(false);
                setLoading(true);
            } else {
                setLoading(false);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    if (loading) return <Loader />;

    return (
        <Container>
            <Card className={styles.paymentCard}>
                <Card.Header className={styles.cardHeader}>
                    <Card.Title className={styles.cardTitle}>Pagamentos</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Row>
                        {/* Cart summary */}
                        <Col md={{ span: 6, order: 2 }} className={styles.paymentMethods}>
                            <CartResume
                                paymentApproved={paymentApproved}
                                items={itensPagamento}
                                discount={desconto}
                            />
                        </Col>

                        {/* Payment methods */}

                        {/* Mercado Pago */}
                        <Col md={{ span: 6, order: 1 }} className={styles.paymentMethods}>
                            {mounted && itensPagamento.length > 0 && !loading && (!payed ? (
                                <PaymentBrick
                                    paymentId={paymentId || ''}
                                    preferenceId={preferenceId}
                                    paymentMethods={paymentMethods}
                                    amount={itensPagamento.reduce((total, item) => total + item.valor, 0)}
                                    onSubmit={(paymentId, status) => {
                                        setPayed(true);
                                        setPaymentMpId(paymentId);
                                        setPaymentApproved(status === 'approved');
                                    }}
                                    onUpdateValues={(numParcelas, valorParcelaF, valorTotal, acrescimo) => {
                                        desconto.current = acrescimo !== 0 ? -acrescimo : 0;
                                    }}
                                />
                            ) : (
                                <StatusBrick
                                    paymentMpId={paymentMpId || ''}
                                    paymentId={paymentId || ''}
                                    onChange={(status) => {
                                        if (status === 'approved') {
                                            setPaymentApproved(true);
                                        } else {
                                            setPaymentApproved(false);
                                        }
                                    }}
                                />
                            ))}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Payment;
